export enum WatchConnectionType {
    bluetooth = "bluetooth",
    web = "web",
}

export type watchModel = {
    make?: string;
    model: string;
    watchOS: string;
    datePaired?: number;
    sessionId?: string;
    platform?: string;
    connectionType?: WatchConnectionType;
    isPaired?: boolean; // mainly used for Garmin known vs selected
};
